export const NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "AI Academy", to: "/ai-academy", full: "VION AI Academy" },
  { label: "AI Solutions", to: "/ai-solutions", full: "VION AI Solutions" },
  { label: "VION Consult", to: "/vion-consult" },
  { label: "Partnerships", to: "/partnerships" },
  { label: "Contact", to: "/contact" },
];

export const SERVICES = [
  "VION AI Academy",
  "VION AI Solutions",
  "VION Consult",
  "Corporate Training",
  "Partnership",
  "Sponsorship",
  "Other",
];

export const LEAD_STATUSES = ["New", "Contacted", "Qualified", "Converted", "Closed"];

export const enquire = (service, topic) => {
  const p = new URLSearchParams({ service });
  if (topic) p.set("topic", topic);
  return `/contact?${p.toString()}`;
};

export const MARQUEE_WORDS = [
  "Artificial Intelligence",
  "Technology Education",
  "AI Automation",
  "Digital Transformation",
  "Technology Consulting",
  "Career Development",
  "International Education",
  "Global Opportunities",
];
